import { AlertBox, Icon } from '@iwoca/orion';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { AlertStatusTypes } from './TrueLayer';
import {
    TRUELAYER_CANCEL,
    TRUELAYER_FAILURE,
    TRUELAYER_SUCCESS
} from './truelayer.constants';
import messages from './TrueLayer.messages';
import styles from './trueLayer.module.css';

export const TruelayerAlertBox = ({
    status,
    handleFailureButtonClick,
    handleCancelButtonClick
}: {
    status: AlertStatusTypes;
    handleFailureButtonClick: () => void;
    handleCancelButtonClick: () => void;
}) => {
    if (status === TRUELAYER_SUCCESS) {
        return (
            <AlertBox
                variant={status}
                className={styles.alertBox}
                data-testid="alertbox"
            >
                <Icon
                    width={20}
                    height={20}
                    icon="checkCircleFilled"
                    className={styles.successAlertBoxIcon}
                />
                <span
                    className={cn(
                        styles.alertBoxContent,
                        styles.successAlertBoxTextContent
                    )}
                >
                    <FormattedMessage {...messages.linked} />
                </span>
            </AlertBox>
        );
    }
    if (status === TRUELAYER_CANCEL) {
        return (
            <AlertBox
                variant={status}
                className={styles.alertBox}
                data-testid="alertbox"
            >
                <Icon
                    width={20}
                    height={20}
                    icon="banOutline"
                    className={styles.cancelAlertBoxIcon}
                />
                <span
                    className={cn(
                        styles.alertBoxContent,
                        styles.cancelAlertBoxTextContent
                    )}
                >
                    <span className={styles.bold}>
                        <FormattedMessage {...messages.noPermission} />
                    </span>{' '}
                    <button
                        type="button"
                        data-testid="uploadBankStatements"
                        onClick={handleCancelButtonClick}
                        className={styles.link}
                    >
                        <FormattedMessage {...messages.noPermissionButton} />
                    </button>
                </span>
            </AlertBox>
        );
    }

    return (
        <AlertBox
            variant={TRUELAYER_FAILURE}
            className={styles.alertBox}
            data-testid="alertbox"
        >
            <Icon
                width={20}
                height={20}
                icon="exclamationTriangleFilled"
                className={styles.failureAlertBoxIcon}
            />
            <span
                className={cn(
                    styles.alertBoxContent,
                    styles.cancelAlertBoxTextContent
                )}
            >
                <span className={styles.bold}>
                    <FormattedMessage {...messages.failed} />
                </span>{' '}
                <span className={styles.light}>
                    <FormattedMessage
                        {...messages.tryAgain}
                        values={{
                            button: (
                                <button
                                    type="button"
                                    data-testid="uploadBankStatements"
                                    onClick={handleFailureButtonClick}
                                    className={styles.link}
                                >
                                    <FormattedMessage
                                        {...messages.tryAgainButton}
                                    />
                                </button>
                            )
                        }}
                    />
                </span>
            </span>
        </AlertBox>
    );
};
